interface ResourceSalesRoomProps {
  playerResources: Record<string, number>;
  playerMoney: number;
  onSell: (resources: Record<string, number>) => Promise<void>;
  onBack: () => void;
}

export default function ResourceSalesRoom({
  playerResources,
  playerMoney,
  onSell,
  onBack,
}: ResourceSalesRoomProps) {
  return (
    <div className="resource-sales-room">
      <h2 className="room-title">
        <span>💰</span>
        RESOURCE SALES - TRADING POST
      </h2>

      <div className="room-content">
        <div className="resources-list">
          <p>Your Resources:</p>
          {Object.entries(playerResources).map(([resource, amount]) => (
            <div key={resource} className="resource-item">
              <span>{resource}:</span>
              <span>{amount} units</span>
            </div>
          ))}
        </div>

        <p className="info">Resource sales coming soon...</p>
      </div>

      <button className="back-button" onClick={onBack}>← Back to Lobby</button>
    </div>
  );
}

